"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectDeclarations = exports.detectDeclarationsBySentence = exports.detectDeclarationsByEL = void 0;
const processNameInline_1 = require("./processNameInline");
const controls_1 = require("../../node/el/controls");
const processLawRef_1 = require("./processLawRef");
const common_1 = require("../common");
const processNameList_1 = require("./processNameList");
const declarations_1 = require("../common/declarations");
const processAmbiguousNameInline_1 = require("./processAmbiguousNameInline");
const detectDeclarationsByEL = (elToBeModified, sentenceEnv, sentenceEnvsStruct, pointerEnvsStruct, lawTitleLength) => {
    const declarations = [];
    const lawRefs = [];
    const errors = [];
    {
        const result = (0, processLawRef_1.processLawRef)(elToBeModified, sentenceEnv, sentenceEnvsStruct, pointerEnvsStruct, lawTitleLength);
        if (result) {
            declarations.push(...result.value.declarations);
            lawRefs.push(...result.value.lawRefs);
            errors.push(...result.errors);
        }
    }
    {
        const result = (0, processNameInline_1.processNameInline)(elToBeModified, sentenceEnv, sentenceEnvsStruct, pointerEnvsStruct);
        if (result) {
            declarations.push(...result.value.declarations);
            errors.push(...result.errors);
        }
    }
    for (const child of elToBeModified.children) {
        if (typeof child === "string") {
            continue;
        }
        else if ((0, common_1.isIgnoreAnalysis)(child)) {
            continue;
        }
        else if (child instanceof controls_1.____LawRef) {
            continue;
        }
        else {
            const detectLawnameResult = (0, exports.detectDeclarationsByEL)(child, sentenceEnv, sentenceEnvsStruct, pointerEnvsStruct, lawTitleLength);
            declarations.push(...detectLawnameResult.value.declarations);
            lawRefs.push(...detectLawnameResult.value.lawRefs);
            errors.push(...detectLawnameResult.errors);
        }
    }
    return { value: { declarations, lawRefs }, errors };
};
exports.detectDeclarationsByEL = detectDeclarationsByEL;
const detectDeclarationsBySentence = (sentenceEnv, sentenceEnvsStruct, pointerEnvsStruct, lawTitleLength) => {
    const declarations = [];
    const lawRefs = [];
    const errors = [];
    {
        const result = (0, processNameList_1.processNameList)(sentenceEnv, sentenceEnvsStruct, pointerEnvsStruct);
        if (result) {
            declarations.push(...result.value);
            errors.push(...result.errors);
        }
    }
    {
        const result = (0, exports.detectDeclarationsByEL)(sentenceEnv.el, sentenceEnv, sentenceEnvsStruct, pointerEnvsStruct, lawTitleLength);
        if (result) {
            declarations.push(...result.value.declarations);
            lawRefs.push(...result.value.lawRefs);
            errors.push(...result.errors);
        }
    }
    return { value: { declarations, lawRefs }, errors };
};
exports.detectDeclarationsBySentence = detectDeclarationsBySentence;
const detectDeclarations = (sentenceEnvsStruct, pointerEnvsStruct, lawTitleLength) => {
    const declarations = new declarations_1.Declarations();
    const lawRefByDeclarationID = new Map();
    const errors = [];
    for (const sentenceEnv of sentenceEnvsStruct.sentenceEnvs) {
        const result = (0, exports.detectDeclarationsBySentence)(sentenceEnv, sentenceEnvsStruct, pointerEnvsStruct, lawTitleLength);
        if (result) {
            for (const declaration of result.value.declarations)
                declarations.add(declaration);
            for (const lawRef of result.value.lawRefs) {
                if (lawRef.attr.includingDeclarationID) {
                    lawRefByDeclarationID.set(lawRef.attr.includingDeclarationID, lawRef);
                }
                sentenceEnv.addPointerLike({
                    textRange: sentenceEnv.textRageOfEL(lawRef),
                    pointerLike: lawRef,
                });
            }
            errors.push(...result.errors);
        }
    }
    {
        const result = (0, processAmbiguousNameInline_1.processAmbiguousNameInline)(sentenceEnvsStruct, declarations, pointerEnvsStruct);
        errors.push(...result.errors);
        for (const declaration of result.value.toAddDeclarations)
            declarations.add(declaration);
    }
    return { value: { declarations, lawRefByDeclarationID }, errors };
};
exports.detectDeclarations = detectDeclarations;
exports.default = exports.detectDeclarations;
//# sourceMappingURL=index.js.map